import "./GiftingBundles.module.css";
import Header from "@/reusable_sections/Header";
import Chill from "./sections/Chill";
import Bundles from "./sections/Bundles";
import GiftSelection from "./sections/GiftSelection";
import Footer from "@/reusable_sections/Footer";
export default function GiftingBundlesPage() {
  return <div>
      <Header />
      <Chill />
      <Bundles />
      <GiftSelection />
      <Footer />
    </div>;
}